import { AxiosError } from 'axios'
import { createAxiosInstance } from '~/lib/api/createAxiosInstance'
import type { CurrencyExchangeRates } from '~/models'

type FetchInternalCurrencyExchangeArgs = {
  currencyFrom: string
  currencyTo: string
}

type FetchInternalCurrencyExchangeResult =
  | { data: CurrencyExchangeRates }
  | { error: { status?: number; data: unknown } }

const internalApiClient = createAxiosInstance({})

export async function fetchInternalCurrencyExchange({
  currencyFrom,
  currencyTo,
}: FetchInternalCurrencyExchangeArgs): Promise<FetchInternalCurrencyExchangeResult> {
  try {
    const result = await internalApiClient<CurrencyExchangeRates[]>({
      url: 'metadata/currency/exchange',
      method: 'GET',
      params: {
        currencyFrom,
        currencyTo,
      },
    })

    return { data: result.data[0] }
  } catch (axiosError) {
    const err = axiosError as AxiosError

    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    }
  }
}
